import { render } from "./AdminTree.vue?vue&type=template&id=d37a0ce2&scoped=true"
import script from "./AdminTree.vue?vue&type=script&lang=js"
export * from "./AdminTree.vue?vue&type=script&lang=js"

import "./AdminTree.vue?vue&type=style&index=0&id=d37a0ce2&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37a0ce2"]])

export default __exports__